export default __webpack_public_path__ + "static/media/Careplatform_logo.4d191e21.png";